import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('meeting_point_id'),
	fieldsMap.get('time'),
	// fieldsMap.get('type'),
	fieldsMap.get('list_id'),
	fieldsMap.get('note')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
